import api from "@/lib/axios";
import { getEnv } from "@/lib/env";
import { Position, PositionSchema } from "@/models/position";
import { UserInfo, UserInfoSchema } from "@/models/user";
import { createFileRoute } from "@tanstack/react-router";
import SharePageClient from "./-components/SharePageClient";

export const Route = createFileRoute("/share/$positionId/$version")({
  loader: async ({ params }) => {
    const { positionId } = params;

    const { data: positionResponse } = await api.get<Position>(
      `/positions/${positionId}`,
    );
    const position = PositionSchema.parse(positionResponse);
    const { data: userResponse } = await api.get<UserInfo>(
      `/positions/${positionId}/user-info`,
    );
    const userInfo = UserInfoSchema.parse(userResponse);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { unrealizedPnl, totalPnl, ...serializablePosition } = position;

    return {
      position: serializablePosition,
      userInfo,
    };
  },
  head: async ({ params, loaderData }) => {
    const { position, userInfo } = loaderData!;
    const { positionId, version } = params;

    try {
      const imageUrl = `${getEnv.VITE_CDN_URL}/positions/${positionId}/${version}.webp`;
      const displayName = userInfo?.handle || userInfo?.name || "Unknown User";
      const title = `${displayName} ${position.token.symbol} Position`;
      const pnlText = position.realized_pnl_percentage > 0 ? "+" : "";
      const description = `Check out my ${position.token.symbol} trading position - ${pnlText}${position.realized_pnl_percentage.toFixed(2)}% P&L`;

      return {
        meta: [
          { title },
          { name: "description", content: description },
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          { property: "og:image", content: imageUrl },
          { property: "og:image:width", content: "734" },
          { property: "og:image:height", content: "470" },
          { property: "og:type", content: "website" },
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          { name: "twitter:image", content: imageUrl },
        ],
      };
    } catch (error) {
      console.error("Error generating metadata:", error);
      return {
        meta: [
          { title: "Share Not Found" },
          {
            name: "description",
            content: "The requested share could not be found.",
          },
        ],
      };
    }
  },
  component: SharePage,
});

function SharePage() {
  return <SharePageClient />;
}
